module.exports = __webpack_public_path__ + "static/media/n_icon_tab_left@2x.68f9ed3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/n_icon_tab_left@2x.png
// module id = 1818
// module chunks = 0 1